import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConsultaInformeSolicitudesI } from 'src/app/infraestructure/models/consultaInformeSolicitudes';

@Component({
  selector: 'app-table-request-report',
  templateUrl: './table-request-report.component.html',
  styleUrls: ['./table-request-report.component.scss']
})
export class TableRequestReportComponent implements OnInit{

  @Input() dataTable: ConsultaInformeSolicitudesI[] = [];
  @Output() export = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  onExport() {
    this.export.emit(true);
  }
}
